import { createMuiTheme, krowdyTheme } from '@krowdy-ui/core'
import { ColorPartial, SimplePaletteColorOptions } from '@material-ui/core/styles/createPalette'

export type PaletteColor = SimplePaletteColorOptions & ColorPartial & { 10?: string | undefined;}

const theme = createMuiTheme(krowdyTheme)

export default theme
